/* Svensk katalog for locale-autopilot-sales.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'ap.agent.sales.title': 'Fakturor och offerter',
  'ap.agent.sales.pending': '{{count}} dokument har inte skickats.',
  'ap.agent.sales.detail': 'Skicka färdiga fakturor och offerter. Utkast måste slutföras i fakturalistan.',
  'ap.agent.sales.draft': 'Utkast',
  'ap.agent.sales.invoices': 'Fakturor',
  'ap.agent.sales.drafts': 'Utkast',
  'ap.agent.sales.offers': 'Offerter',
  'ap.agent.offer.sendSelected': 'Skicka {{count}} valda offerter',
  'ap.agent.sales.sentCount': '{{count}} offerter skickade',
  'ap.agent.sales.send': 'Skicka',
  'ap.agent.sales.open': 'Öppna',
  'ap.agent.sales.empty': 'Inga oskickade dokument i den här listan.',
  'ap.agent.sales.unavailable': 'Dokumentet kan inte skickas. Öppna fakturalistan för att kontrollera status.',
  'ap.agent.sales.emailMissing': 'Kunden saknar e-postadress. Lägg till den i fakturalistan innan du skickar.',
  'ap.agent.sales.sendFailed': 'Dokumentet skickades inte. Försök igen från fakturalistan.',
});
